export default "__VITE_ASSET__CFKvJiB7__"